module.exports = "/images/gi.svg?7b07a9cbacf5d51fa984d3b65d2889c1";